import styles from './ModerationGuidelines.module.scss'
import {BaseModal} from '../../../../components/BaseModal/BaseModal'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {DIALOG} from '../../../../Translation/English/dialog'

interface IModerationGuidelinesProps {
  showModal: boolean
  setShowModal: (show: boolean) => void
}

export const ModerationGuidelines: React.FC<IModerationGuidelinesProps> = ({
  showModal,
  setShowModal,
}) => {
  const wt = useWt()

  return (
    <BaseModal
      visible={showModal}
      headerTitle={wt(DIALOG.communityGuidelinesHeading)}
      onCloseModal={() => setShowModal(false)}
      maxWidth="800px"
    >
      <div className={styles.moderationGuidelines}>
        <div>{wt(DIALOG.guidelinesDescription)}</div>
        <div>
          <div className={styles.moderationGuidelinesTitle}>
            What we encourage
          </div>
          <ul className={styles.moderationGuidelinesList}>
            <li className={styles.moderationGuidelinesListItem}>
              Sharing your genuine perspective on the question being asked.
            </li>
            <li className={styles.moderationGuidelinesListItem}>
              Engaging with other responses respectfully, even when you
              disagree.
            </li>
            <li className={styles.moderationGuidelinesListItem}>
              Asking questions and raising concerns constructively.
            </li>
            <li className={styles.moderationGuidelinesListItem}>
              {wt(DIALOG.text1)}
            </li>
          </ul>
        </div>
        <div>
          <div className={styles.moderationGuidelinesTitle}>
            What is not allowed
          </div>
          <div>
            <span className={styles.moderationGuidelinesCategory}>
              Hate speech and slurs:
            </span>
            <span>
              Language targeting individuals or groups based on race, religion,
              gender, orientation, or disability is not permitted.
            </span>
          </div>
          <div>
            <span className={styles.moderationGuidelinesCategory}>
              Personal threats and harassment:
            </span>
            <span>
              Direct or implied threats, intimidation, or sustained targeting of
              individuals will be removed immediately.
            </span>
          </div>
          <div>
            <span className={styles.moderationGuidelinesCategory}>
              Workplace Inappropriate Language:
            </span>
            <span>
              Any graphic sexual language, profanity, or explicit content that
              is offensive or inappropriate for a professional workplace
              context.
            </span>
          </div>
          <div>
            <span className={styles.moderationGuidelinesCategory}>
              Sharing personal information:
            </span>
            <span>
              Do not share identifying details (Doxxing) about any other person
              without their consent.
            </span>
          </div>
        </div>

        <div>
          <div className={styles.moderationGuidelinesTitle}>
            How moderation works
          </div>
          <div>
            Conversations uses an AI-powered moderation system that reviews
            comments as they are submitted. If a comment is flagged, it is
            hidden while a moderator reviews it.
          </div>
          <div>{wt(DIALOG.text2)}</div>
        </div>
        <div>
          <div className={styles.moderationGuidelinesTitle}>
            Anonymity and its limits
          </div>
          <div>
            Your name and identity are never visible. However, anonymity is a
            privilege—it does not exempt anyone from following these safety
            guidelines.
          </div>
        </div>

        <div>
          <div className={styles.moderationGuidelinesTitle}>
            A note on disagreement
          </div>
          <div>
            Critical feedback and dissent are welcome. The measure of a response
            is whether it respects the people reading it.
          </div>
        </div>
        <div>
          <div className={styles.moderationGuidelinesTitle}>
            Questions or concerns
          </div>
          If you believe a moderation decision was made in error, please contact
          your moderator directly. They can review the situation and take any
          necessary steps.
        </div>
        <div className={styles.moderationGuidelinesFooter}>
          These guidelines apply to all comments and replies submitted in any
          Conversation. They may be updated from time to time to reflect changes
          in how the platform is used.
        </div>
      </div>
    </BaseModal>
  )
}
